import { render, staticRenderFns } from "./yshHeader.vue?vue&type=template&id=2825b9ec&scoped=true&"
import script from "./yshHeader.vue?vue&type=script&lang=js&"
export * from "./yshHeader.vue?vue&type=script&lang=js&"
import style0 from "./yshHeader.vue?vue&type=style&index=0&id=2825b9ec&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2825b9ec",
  null
  
)

export default component.exports